export default {"src":"/_next/static/image/public/imgs/list-your-bike/ready_to_earn.07cac8c34b358cf354837e460f202b92.svg","height":370,"width":530};